import { accountActionTypes } from "../../actionTypes/accounts/account.actionTypes";

const initialState = {
  stateInfo: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    error: null,
  },
  token: localStorage.getItem("jwtToken") || null,
  isAuthenticated: !!localStorage.getItem("jwtToken"),
  isLoggedIn: !!localStorage.getItem("jwtToken"), // Added for clarity
  userInfo: null,
  usersByBusiness: [],
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case accountActionTypes.START_LOGIN:
    case accountActionTypes.START_REGISTER_BUSINESS:
    case accountActionTypes.START_GET_USER_INFO:
    case accountActionTypes.START_GET_USERS_BY_BUSINESS:
    case accountActionTypes.START_DELETE_ACCOUNT:
      return setStateLoading(state);

    case accountActionTypes.LOGIN_SUCCESS:
      return setLoginSuccess(state, action);
    
      case accountActionTypes.GET_USERS_BY_BUSINESS_SUCCESS:
      return setUsersByBusinessSuccess(state, action);

    case accountActionTypes.REGISTER_BUSINESS_SUCCESS:
    case accountActionTypes.DELETE_ACCOUNT_SUCCESS:
      return setStateSuccess(state);

    case accountActionTypes.GET_USER_INFO_SUCCESS:
      return setUserInfoSuccess(state, action);

    case accountActionTypes.LOGIN_FAILURE:
    case accountActionTypes.REGISTER_BUSINESS_FAILURE:
    case accountActionTypes.GET_USER_INFO_FAILURE:
    case accountActionTypes.GET_USERS_BY_BUSINESS_FAILURE:
    case accountActionTypes.DELETE_ACCOUNT_FAILURE:
      return setStateFailure(state, action);

    case accountActionTypes.LOGOUT:
      return setStateLogout(state);

    default:
      return state;
  }
};

// Helper Functions

const setStateLoading = (state) => ({
  ...state,
  stateInfo: {
    isLoading: true,
    isSuccess: false,
    isError: false,
    error: null,
  },
});

const setStateFailure = (state, action) => ({
  ...state,
  stateInfo: {
    isLoading: false,
    isSuccess: false,
    isError: true,
    error: action.error || "An unexpected error occurred.",
  },
});

const setStateSuccess = (state) => ({
  ...state,
  stateInfo: {
    isLoading: false,
    isSuccess: true,
    isError: false,
    error: null,
  },
});

const setLoginSuccess = (state, action) => {
  const token = action.data;
  localStorage.setItem("jwtToken", token);
  return {
    ...state,
    stateInfo: {
      isLoading: false,
      isSuccess: true,
      isError: false,
      error: null,
    },
    token,
    isAuthenticated: true,
    isLoggedIn: true,
  };
};

const setUsersByBusinessSuccess = (state, action) => {
  return {
    ...state,
    stateInfo: { isLoading: false, isSuccess: true, isError: false, error: null },
    usersByBusiness: action.data,
  };
};

const setStateLogout = (state) => {
  localStorage.removeItem("jwtToken");
  return {
    ...state,
    stateInfo: {
      isLoading: false,
      isSuccess: true,
      isError: false,
      error: null,
    },
    token: null,
    isAuthenticated: false,
    isLoggedIn: false,
    userInfo: null,
  };
};

const setUserInfoSuccess = (state, action) => ({
  ...state,
  stateInfo: {
    isLoading: false,
    isSuccess: true,
    isError: false,
    error: null,
  },
  userInfo: action.data,
});

export default accountReducer;
